import { trackEvent, event } from '@zillow/universal-analytics';
import React, { createElement } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { isLocalStorageSupported } from '@zillow/is-local-storage-supported';
import get from 'lodash/get';
import { v4 } from 'uuid';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

/**** forward slashes ****/
var ADJUST_BASE_URL = 'https://app.us.adjust.com/';
var ADJUST_BASE_UNIVERSAL_LINK = 'https://r3fc.us.adj.st';
var APP_UPSELL_DISMISS = 'APP_UPSELL_DISMISS_080620';
var DEFAULT_DISMISS_KEY = 'APP_UPSELL_DISMISS_080620';
var DISMISS_DURATION = 24 * 60 * 60 * 14 * 1000;
var DISMISS_DURATION_24_HRS = 24 * 60 * 60 * 1 * 1000;
var ACQ_Deeplink_DirectOpen = 'ACQ_Deeplink_DirectOpen';
var ACQ_Banner_Suppression = 'ACQ_Banner_Suppression';
var DEFAULT_ADJUST_TRACKER = 'rw2qau8_ra7mjoq';
var SITEWIDE_ADJUST_TRACKERS = {
  ACQ_Deeplink_DirectOpen: {
    CONTROL: '70qasoh_avr5gzk',
    AA: 'h45ruvi_ufm824p',
    Variant: 'rw2qau8_ra7mjoq'
  },
  ACQ_Banner_Suppression: {
    CONTROL: 'rw2qau8_ra7mjoq',
    Variant_3dismiss: 'klo3vye_fo4k0tg'
  }
};
var IMPRESSION_SEARCH_AND_HDP = 'IMPRESSION_SEARCH_AND_HDP';
var DOWNLOAD_CTA_CLICK_SEARCH_AND_HDP = 'DOWNLOAD_CTA_CLICK_SEARCH_AND_HDP';
var DISMISS_CLICK_SEARCH_AND_HDP = 'DISMISS_CLICK_SEARCH_AND_HDP';
var IMPRESSION_HOMEPAGE = 'IMPRESSION_HOMEPAGE';
var DOWNLOAD_CTA_CLICK_HOMEPAGE = 'DOWNLOAD_CTA_CLICK_HOMEPAGE';
var CONTINUE_HOMEPAGE = 'CONTINUE_HOMEPAGE';
var IMPRESSION_SAVE_HOME = 'IMPRESSION_SAVE_HOME';
var DOWNLOAD_CTA_CLICK_SAVE_HOME = 'DOWNLOAD_CTA_CLICK_SAVE_HOME';
var DISMISS_SAVE_HOME = 'DISMISS_SAVE_HOME';
var CONTINUE_ON_MWEB_SAVE_HOME = 'CONTINUE_ON_MWEB_SAVE_HOME';
var IMPRESSION_HDP_VIA_EMAIL = 'IMPRESSION_HDP_VIA_EMAIL';
var DOWNLOAD_CTA_HDP_VIA_EMAIL = 'DOWNLOAD_CTA_HDP_VIA_EMAIL';
var CONTINUE_ON_MWEB_HDP_VIA_EMAIL = 'CONTINUE_ON_MWEB_HDP_VIA_EMAIL';
var DISMISS_HDP_VIA_EMAIL = 'DISMISS_HDP_VIA_EMAIL';
var CLICKS_INSTALL = 'Clicks_Install';
var CLICKS_MWEB = 'Clicks_Mweb';
var DISMISS = 'Dismiss';
var HOME_DETAILS = 'home_details';
var SEARCH_RESULT = 'search_results';
var HOME = 'home';
var HDP = 'HDP';
var SEARCH = 'Search';
var HOMEPAGE = 'Homepage';
var SAVE_HOME = 'save_home';
var SAVED_HOME = 'saved_home';
var EVENT_TEMPLATE_ID = '171';
var APP_DOWNLOAD_BANNER = 'app_download_banner';
var HOME_DETAILS_DEEPLINK = 'home_details|deeplink';
var EVENT_TYPE_IDS = {
  IMPRESSION_SEARCH_AND_HDP: '4613',
  DOWNLOAD_CTA_CLICK_SEARCH_AND_HDP: '4614',
  DISMISS_CLICK_SEARCH_AND_HDP: '4615',
  IMPRESSION_HOMEPAGE: '4616',
  DOWNLOAD_CTA_CLICK_HOMEPAGE: '4617',
  CONTINUE_HOMEPAGE: '4619',
  IMPRESSION_SAVE_HOME: '4622',
  DOWNLOAD_CTA_CLICK_SAVE_HOME: '4623',
  DISMISS_SAVE_HOME: '4624',
  CONTINUE_ON_MWEB_SAVE_HOME: '4625',
  IMPRESSION_HDP_VIA_EMAIL: '4626',
  DOWNLOAD_CTA_HDP_VIA_EMAIL: '4627',
  DISMISS_HDP_VIA_EMAIL: '4628',
  CONTINUE_ON_MWEB_HDP_VIA_EMAIL: '4629'
};
var TRIGGER_TYPE_NM = {
  IMPRESSION_SEARCH_AND_HDP: 'impression',
  DOWNLOAD_CTA_CLICK_SEARCH_AND_HDP: 'interaction',
  DISMISS_CLICK_SEARCH_AND_HDP: 'interaction',
  IMPRESSION_HOMEPAGE: 'impression',
  DOWNLOAD_CTA_CLICK_HOMEPAGE: 'interaction',
  CONTINUE_HOMEPAGE: 'interaction',
  IMPRESSION_SAVE_HOME: 'impression',
  DOWNLOAD_CTA_CLICK_SAVE_HOME: 'interaction',
  DISMISS_SAVE_HOME: 'interaction',
  CONTINUE_ON_MWEB_SAVE_HOME: 'interaction',
  IMPRESSION_HDP_VIA_EMAIL: 'impression',
  DOWNLOAD_CTA_HDP_VIA_EMAIL: 'interaction',
  CONTINUE_ON_MWEB_HDP_VIA_EMAIL: 'interaction',
  DISMISS_HDP_VIA_EMAIL: 'interaction'
};
var TRIGGER_OBJECT_NM = {
  IMPRESSION_SEARCH_AND_HDP: 'no_trigger_object',
  DOWNLOAD_CTA_CLICK_SEARCH_AND_HDP: 'app_download_banner|cta_click',
  DISMISS_CLICK_SEARCH_AND_HDP: 'app_download_banner|dismiss',
  IMPRESSION_HOMEPAGE: 'app_download_banner|view',
  DOWNLOAD_CTA_CLICK_HOMEPAGE: 'app_download_banner|cta_click',
  CONTINUE_HOMEPAGE: 'app_download_banner|not_now',
  IMPRESSION_SAVE_HOME: 'app_download_banner|view',
  DOWNLOAD_CTA_CLICK_SAVE_HOME: 'app_download_banner|cta_click',
  DISMISS_SAVE_HOME: 'app_download_banner|dismiss',
  CONTINUE_ON_MWEB_SAVE_HOME: 'app_download_banner|not_now',
  IMPRESSION_HDP_VIA_EMAIL: 'app_download_banner|view',
  DOWNLOAD_CTA_HDP_VIA_EMAIL: 'app_download_banner|cta_click',
  CONTINUE_ON_MWEB_HDP_VIA_EMAIL: 'app_download_banner|not_now',
  DISMISS_HDP_VIA_EMAIL: 'app_download_banner|dismiss'
};
var SEMANTIC_EVENT_NM = {
  IMPRESSION_SEARCH_AND_HDP: 'view_content',
  DOWNLOAD_CTA_CLICK_SEARCH_AND_HDP: 'app_download_banner_cta_click',
  DISMISS_CLICK_SEARCH_AND_HDP: 'app_download_banner_dismiss',
  IMPRESSION_HOMEPAGE: 'view_content',
  DOWNLOAD_CTA_CLICK_HOMEPAGE: 'app_download_banner_cta_click',
  CONTINUE_HOMEPAGE: 'app_download_banner_not_now',
  IMPRESSION_SAVE_HOME: 'view_content',
  DOWNLOAD_CTA_CLICK_SAVE_HOME: 'app_download_banner_cta_click',
  DISMISS_SAVE_HOME: 'app_download_banner_dismiss',
  CONTINUE_ON_MWEB_SAVE_HOME: 'app_download_banner_not_now',
  IMPRESSION_HDP_VIA_EMAIL: 'view_content',
  DOWNLOAD_CTA_HDP_VIA_EMAIL: 'app_download_banner_cta_click',
  CONTINUE_ON_MWEB_HDP_VIA_EMAIL: 'app_download_banner_not_now',
  DISMISS_HDP_VIA_EMAIL: 'app_download_banner_dismiss'
};

var getEnvelopeBlock = function getEnvelopeBlock(eventName) {
  return {
    event_template_id: EVENT_TEMPLATE_ID,
    event_template_version_id: '1',
    event_type_id: EVENT_TYPE_IDS[eventName],
    event_type_version_id: '1',
    event_client_start_dtm: new Date().toISOString()
  };
};

var getClickstreamBlock = function getClickstreamBlock(eventName, triggerLocation) {
  return {
    trigger_location_nm: triggerLocation,
    trigger_type_nm: TRIGGER_TYPE_NM[eventName],
    trigger_object_nm: TRIGGER_OBJECT_NM[eventName],
    trigger_source_nm: APP_DOWNLOAD_BANNER
  };
};

var getSemanticBlock = function getSemanticBlock(eventName) {
  return {
    semantic_event_nm: SEMANTIC_EVENT_NM[eventName],
    topic_tag_txt: []
  };
};

var getOwnedUpsellBlock = function getOwnedUpsellBlock(requestId) {
  return {
    request_id: requestId
  };
};

function getNewLaneProperties(pageType, actionType, displayTrigger, isHDPByEmail, requestId) {
  if (actionType === void 0) {
    actionType = null;
  }

  if (isHDPByEmail === void 0) {
    isHDPByEmail = false;
  }

  var triggerLocation;
  var eventName;

  if ((pageType === HDP || pageType === SEARCH) && !actionType && !isHDPByEmail) {
    // Impression on hdp and search
    triggerLocation = pageType === HDP ? HOME_DETAILS : SEARCH_RESULT;
    eventName = IMPRESSION_SEARCH_AND_HDP;
  } else if (pageType === HOMEPAGE && !actionType) {
    // Impression on homepage
    triggerLocation = HOME;
    eventName = IMPRESSION_HOMEPAGE;
  } else if ((pageType === HDP || pageType === SEARCH) && actionType === CLICKS_INSTALL && !isHDPByEmail) {
    // Install app on HDP and Search
    triggerLocation = pageType === HDP ? HOME_DETAILS : SEARCH_RESULT;
    eventName = DOWNLOAD_CTA_CLICK_SEARCH_AND_HDP;
  } else if ((pageType === HDP || pageType === SEARCH) && actionType === CLICKS_MWEB && !isHDPByEmail) {
    // Dissmiss app banner on HDP and Search
    triggerLocation = pageType === HDP ? HOME_DETAILS : SEARCH_RESULT;
    eventName = DISMISS_CLICK_SEARCH_AND_HDP;
  } else if (pageType === HOMEPAGE && actionType === CLICKS_INSTALL) {
    // Install app banner on HOMEPAGE
    triggerLocation = HOME;
    eventName = DOWNLOAD_CTA_CLICK_HOMEPAGE;
  } else if (pageType === HOMEPAGE && actionType === CLICKS_MWEB) {
    // Homepage app download banner 'Continue' button selection.
    triggerLocation = HOME;
    eventName = CONTINUE_HOMEPAGE;
  } else if (displayTrigger === SAVE_HOME && !actionType) {
    // Impression of app download banner on search saved home screen
    triggerLocation = SAVED_HOME;
    eventName = IMPRESSION_SAVE_HOME;
  } else if (displayTrigger === SAVE_HOME && actionType === CLICKS_INSTALL) {
    // Saved Homes confirmation screen app download banner CTA click
    triggerLocation = SAVED_HOME;
    eventName = DOWNLOAD_CTA_CLICK_SAVE_HOME;
  } else if (displayTrigger === SAVE_HOME && actionType === DISMISS) {
    // Saved Home confirmation page app download banner dismiss.
    triggerLocation = SAVED_HOME;
    eventName = DISMISS_SAVE_HOME;
  } else if (displayTrigger === SAVE_HOME && actionType === CLICKS_MWEB) {
    // Saved Home confirmation screen'continue' to dismiss app download banner.
    triggerLocation = SAVED_HOME;
    eventName = CONTINUE_ON_MWEB_SAVE_HOME;
  } else if (isHDPByEmail && pageType === HDP && !actionType) {
    // Impression of app download banner when customer deeplinks to a mweb or web hdp via an email.
    triggerLocation = HOME_DETAILS_DEEPLINK;
    eventName = IMPRESSION_HDP_VIA_EMAIL;
  } else if (isHDPByEmail && pageType === HDP && actionType === CLICKS_INSTALL) {
    // CTA click on app download banner that overlays HDP when a customer navigates to the HDP via a deeplink.
    triggerLocation = HOME_DETAILS_DEEPLINK;
    eventName = DOWNLOAD_CTA_HDP_VIA_EMAIL;
  } else if (isHDPByEmail && pageType === HDP && actionType === CLICKS_MWEB) {
    // Selection of 'Not Now' or 'Continue' on app download banner that appears when a user navigates to the HDP via a deeplink
    triggerLocation = HOME_DETAILS_DEEPLINK;
    eventName = CONTINUE_ON_MWEB_HDP_VIA_EMAIL;
  } else if (isHDPByEmail && pageType === HDP && actionType === DISMISS) {
    // Selection of 'Not Now' or 'Continue' on app download banner that appears when a user navigates to the HDP via a deeplink
    triggerLocation = HOME_DETAILS_DEEPLINK;
    eventName = DISMISS_HDP_VIA_EMAIL;
  }

  var newLaneEvent = {
    semantic: getSemanticBlock(eventName),
    clickstream_trigger: getClickstreamBlock(eventName, triggerLocation),
    envelope: getEnvelopeBlock(eventName),
    owned_upsell: getOwnedUpsellBlock(requestId)
  };
  return {
    newLaneEvent: newLaneEvent
  };
}

var DEFAULT_CATEGORY = 'App_Upsell';
/**
 * Stringify JSON but catch the error just in case
 * @param {Object} jsonObj
 * @returns {String}
 */

var stringify = function stringify(jsonObj) {
  try {
    return JSON.stringify(jsonObj);
  } catch (e) {
    return '{}';
  }
};

var trackImpression = function trackImpression(_ref) {
  var requestId = _ref.requestId,
      _ref$geoIpLocation = _ref.geoIpLocation,
      geoIpLocation = _ref$geoIpLocation === void 0 ? {} : _ref$geoIpLocation,
      regionName = _ref.regionName,
      displayTrigger = _ref.displayTrigger,
      utmCampaign = _ref.utmCampaign,
      pageType = _ref.pageType,
      isHDPByEmail = _ref.isHDPByEmail;
  var city = geoIpLocation.city,
      zipcode = geoIpLocation.zipcode;
  var newLaneProperties = getNewLaneProperties(pageType, null, displayTrigger, isHDPByEmail, requestId);
  trackEvent({
    category: DEFAULT_CATEGORY,
    action: 'Display',
    label: stringify({
      requestId: requestId,
      city: city || 'NA',
      zipcode: zipcode || -1,
      currentGeo: regionName || 'NA',
      displayTrigger: displayTrigger,
      utmCampaign: utmCampaign
    })
  });
  event(newLaneProperties.newLaneEvent);
};
var trackInteraction = function trackInteraction(_ref2) {
  var requestId = _ref2.requestId,
      actionType = _ref2.actionType,
      _ref2$geoIpLocation = _ref2.geoIpLocation,
      geoIpLocation = _ref2$geoIpLocation === void 0 ? {} : _ref2$geoIpLocation,
      regionName = _ref2.regionName,
      displayTrigger = _ref2.displayTrigger,
      utmCampaign = _ref2.utmCampaign,
      errorMessage = _ref2.errorMessage,
      pageType = _ref2.pageType,
      isHDPByEmail = _ref2.isHDPByEmail;
  var city = geoIpLocation.city,
      zipcode = geoIpLocation.zipcode;
  var newLaneProperties = getNewLaneProperties(pageType, actionType, displayTrigger, isHDPByEmail, requestId);
  trackEvent({
    category: DEFAULT_CATEGORY,
    action: actionType,
    label: stringify({
      requestId: requestId,
      city: city || 'NA',
      zipcode: zipcode || -1,
      currentGeo: regionName || 'NA',
      displayTrigger: displayTrigger,
      utmCampaign: utmCampaign,
      errorMessage: errorMessage
    })
  });
  event(newLaneProperties.newLaneEvent);
};
var trackError = function trackError(_ref3) {
  var requestId = _ref3.requestId,
      actionType = _ref3.actionType,
      displayTrigger = _ref3.displayTrigger,
      errorMessage = _ref3.errorMessage;
  trackEvent({
    category: DEFAULT_CATEGORY,
    action: actionType,
    label: stringify({
      requestId: requestId,
      displayTrigger: displayTrigger,
      errorMessage: errorMessage
    })
  });
};

/**
 * Component that fires the impression GA and renders the actual message
 */

var TrackImpression = (function (_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  trackImpression(props);
  return children || null;
});

var _jsxFileName$4 = "/builds/zillow/app-acquisition/app-upsell-utils/src/components/ChromeLogo.js";

function SvgGoogleChromeIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "1 1 176 176"
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 5,
      columnNumber: 5
    }
  }), /*#__PURE__*/createElement("style", {
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 11,
      columnNumber: 7
    }
  }, '.Google_Chrome_icon_svg__B{clip-path:url(#Google_Chrome_icon_svg__C)}.Google_Chrome_icon_svg__C{fill:#3e2723}.Google_Chrome_icon_svg__D{fill-opacity:.15}.Google_Chrome_icon_svg__E{fill-opacity:.2}'), /*#__PURE__*/createElement("defs", {
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 16,
      columnNumber: 7
    }
  }, /*#__PURE__*/createElement("circle", {
    id: "Google_Chrome_icon_svg__A",
    cx: 96,
    cy: 96,
    r: 88,
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 17,
      columnNumber: 9
    }
  }), /*#__PURE__*/createElement("path", {
    id: "Google_Chrome_icon_svg__B",
    d: "M8 184h83.77l38.88-38.88V116h-69.3L8 24.48z",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 18,
      columnNumber: 9
    }
  })), /*#__PURE__*/createElement("clipPath", {
    id: "Google_Chrome_icon_svg__C",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 23,
      columnNumber: 7
    }
  }, /*#__PURE__*/createElement("use", {
    xlinkHref: "#Google_Chrome_icon_svg__A",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 24,
      columnNumber: 9
    }
  })), /*#__PURE__*/createElement("g", {
    className: "Google_Chrome_icon_svg__B",
    transform: "translate(-7 -7)",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 26,
      columnNumber: 7
    }
  }, /*#__PURE__*/createElement("path", {
    d: "M21.97 8v108h39.4L96 56h88V8z",
    fill: "#db4437",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 27,
      columnNumber: 9
    }
  }), /*#__PURE__*/createElement("linearGradient", {
    id: "Google_Chrome_icon_svg__D",
    x1: 29.34,
    x2: 81.84,
    y1: 75.02,
    y2: 44.35,
    gradientUnits: "userSpaceOnUse",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 28,
      columnNumber: 9
    }
  }, /*#__PURE__*/createElement("stop", {
    stopColor: "#a52714",
    stopOpacity: 0.6,
    offset: 0,
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 36,
      columnNumber: 11
    }
  }), /*#__PURE__*/createElement("stop", {
    stopColor: "#a52714",
    stopOpacity: 0,
    offset: 0.66,
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 37,
      columnNumber: 11
    }
  })), /*#__PURE__*/createElement("path", {
    d: "M21.97 8v108h39.4L96 56h88V8z",
    fill: "url(#Google_Chrome_icon_svg__D)",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 39,
      columnNumber: 9
    }
  }), /*#__PURE__*/createElement("path", {
    d: "M62.3 115.6L22.48 47.3l-.58 1 39.54 67.8z",
    className: "Google_Chrome_icon_svg__C Google_Chrome_icon_svg__D",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 43,
      columnNumber: 9
    }
  }), /*#__PURE__*/createElement("use", {
    xlinkHref: "#Google_Chrome_icon_svg__B",
    fill: "#0f9d58",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 47,
      columnNumber: 9
    }
  }), /*#__PURE__*/createElement("linearGradient", {
    id: "Google_Chrome_icon_svg__E",
    x1: 110.9,
    x2: 52.54,
    y1: 164.5,
    y2: 130.3,
    gradientUnits: "userSpaceOnUse",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 48,
      columnNumber: 9
    }
  }, /*#__PURE__*/createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0.4,
    offset: 0,
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 56,
      columnNumber: 11
    }
  }), /*#__PURE__*/createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0,
    offset: 0.33,
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 57,
      columnNumber: 11
    }
  })), /*#__PURE__*/createElement("path", {
    d: "M8 184h83.77l38.88-38.88V116h-69.3L8 24.48z",
    fill: "url(#Google_Chrome_icon_svg__E)",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 59,
      columnNumber: 9
    }
  }), /*#__PURE__*/createElement("path", {
    d: "M129.8 117.3l-.83-.48-38.4 67.15h1.15l38.1-66.64z",
    fill: "#263238",
    className: "Google_Chrome_icon_svg__D",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 63,
      columnNumber: 9
    }
  }), /*#__PURE__*/createElement("defs", {
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 68,
      columnNumber: 9
    }
  }, /*#__PURE__*/createElement("path", {
    id: "Google_Chrome_icon_svg__F",
    d: "M8 184h83.77l38.88-38.88V116h-69.3L8 24.48z",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 69,
      columnNumber: 11
    }
  })), /*#__PURE__*/createElement("clipPath", {
    id: "Google_Chrome_icon_svg__G",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 74,
      columnNumber: 9
    }
  }, /*#__PURE__*/createElement("use", {
    xlinkHref: "#Google_Chrome_icon_svg__F",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 75,
      columnNumber: 11
    }
  })), /*#__PURE__*/createElement("g", {
    clipPath: "url(#Google_Chrome_icon_svg__G)",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 77,
      columnNumber: 9
    }
  }, /*#__PURE__*/createElement("path", {
    d: "M96 56l34.65 60-38.88 68H184V56z",
    fill: "#ffcd40",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 78,
      columnNumber: 11
    }
  }), /*#__PURE__*/createElement("linearGradient", {
    id: "Google_Chrome_icon_svg__H",
    x1: 121.9,
    x2: 136.6,
    y1: 49.8,
    y2: 114.1,
    gradientUnits: "userSpaceOnUse",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 79,
      columnNumber: 11
    }
  }, /*#__PURE__*/createElement("stop", {
    stopColor: "#ea6100",
    stopOpacity: 0.3,
    offset: 0,
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 87,
      columnNumber: 13
    }
  }), /*#__PURE__*/createElement("stop", {
    stopColor: "#ea6100",
    stopOpacity: 0,
    offset: 0.66,
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 88,
      columnNumber: 13
    }
  })), /*#__PURE__*/createElement("path", {
    d: "M96 56l34.65 60-38.88 68H184V56z",
    fill: "url(#Google_Chrome_icon_svg__H)",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 90,
      columnNumber: 11
    }
  })), /*#__PURE__*/createElement("path", {
    d: "M96 56l34.65 60-38.88 68H184V56z",
    fill: "#ffcd40",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 95,
      columnNumber: 9
    }
  }), /*#__PURE__*/createElement("path", {
    d: "M96 56l34.65 60-38.88 68H184V56z",
    fill: "url(#Google_Chrome_icon_svg__H)",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 96,
      columnNumber: 9
    }
  }), /*#__PURE__*/createElement("defs", {
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 100,
      columnNumber: 9
    }
  }, /*#__PURE__*/createElement("path", {
    id: "Google_Chrome_icon_svg__I",
    d: "M96 56l34.65 60-38.88 68H184V56z",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 101,
      columnNumber: 11
    }
  })), /*#__PURE__*/createElement("clipPath", {
    id: "Google_Chrome_icon_svg__J",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 106,
      columnNumber: 9
    }
  }, /*#__PURE__*/createElement("use", {
    xlinkHref: "#Google_Chrome_icon_svg__I",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 107,
      columnNumber: 11
    }
  })), /*#__PURE__*/createElement("g", {
    clipPath: "url(#Google_Chrome_icon_svg__J)",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 109,
      columnNumber: 9
    }
  }, /*#__PURE__*/createElement("path", {
    d: "M21.97 8v108h39.4L96 56h88V8z",
    fill: "#db4437",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 110,
      columnNumber: 11
    }
  }), /*#__PURE__*/createElement("path", {
    d: "M21.97 8v108h39.4L96 56h88V8z",
    fill: "url(#Google_Chrome_icon_svg__D)",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 111,
      columnNumber: 11
    }
  }))), /*#__PURE__*/createElement("radialGradient", {
    id: "Google_Chrome_icon_svg__K",
    cx: 668.2,
    cy: 55.95,
    r: 84.08,
    gradientTransform: "translate(-576)",
    gradientUnits: "userSpaceOnUse",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 117,
      columnNumber: 7
    }
  }, /*#__PURE__*/createElement("stop", {
    stopColor: "#3e2723",
    stopOpacity: 0.2,
    offset: 0,
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 125,
      columnNumber: 9
    }
  }), /*#__PURE__*/createElement("stop", {
    stopColor: "#3e2723",
    stopOpacity: 0,
    offset: 1,
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 126,
      columnNumber: 9
    }
  })), /*#__PURE__*/createElement("path", {
    d: "M96 56v20.95L174.4 56z",
    fill: "url(#Google_Chrome_icon_svg__K)",
    className: "Google_Chrome_icon_svg__B",
    transform: "translate(-7 -7)",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 128,
      columnNumber: 7
    }
  }), /*#__PURE__*/createElement("g", {
    className: "Google_Chrome_icon_svg__B",
    transform: "translate(-7 -7)",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 134,
      columnNumber: 7
    }
  }, /*#__PURE__*/createElement("defs", {
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 135,
      columnNumber: 9
    }
  }, /*#__PURE__*/createElement("path", {
    id: "Google_Chrome_icon_svg__L",
    d: "M21.97 8v40.34L61.36 116 96 56h88V8z",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 136,
      columnNumber: 11
    }
  })), /*#__PURE__*/createElement("clipPath", {
    id: "Google_Chrome_icon_svg__M",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 141,
      columnNumber: 9
    }
  }, /*#__PURE__*/createElement("use", {
    xlinkHref: "#Google_Chrome_icon_svg__L",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 142,
      columnNumber: 11
    }
  })), /*#__PURE__*/createElement("g", {
    clipPath: "url(#Google_Chrome_icon_svg__M)",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 144,
      columnNumber: 9
    }
  }, /*#__PURE__*/createElement("use", {
    xlinkHref: "#Google_Chrome_icon_svg__B",
    fill: "#0f9d58",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 145,
      columnNumber: 11
    }
  }), /*#__PURE__*/createElement("path", {
    d: "M8 184h83.77l38.88-38.88V116h-69.3L8 24.48z",
    fill: "url(#Google_Chrome_icon_svg__E)",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 146,
      columnNumber: 11
    }
  }))), /*#__PURE__*/createElement("radialGradient", {
    id: "Google_Chrome_icon_svg__N",
    cx: 597.9,
    cy: 48.52,
    r: 78.04,
    gradientTransform: "translate(-576)",
    gradientUnits: "userSpaceOnUse",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 152,
      columnNumber: 7
    }
  }, /*#__PURE__*/createElement("stop", {
    stopColor: "#3e2723",
    stopOpacity: 0.2,
    offset: 0,
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 160,
      columnNumber: 9
    }
  }), /*#__PURE__*/createElement("stop", {
    stopColor: "#3e2723",
    stopOpacity: 0,
    offset: 1,
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 161,
      columnNumber: 9
    }
  })), /*#__PURE__*/createElement("path", {
    transform: "translate(-7 -7)",
    d: "M21.97 48.45l57.25 57.24L61.36 116z",
    fill: "url(#Google_Chrome_icon_svg__N)",
    className: "Google_Chrome_icon_svg__B",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 163,
      columnNumber: 7
    }
  }), /*#__PURE__*/createElement("radialGradient", {
    id: "Google_Chrome_icon_svg__O",
    cx: 671.8,
    cy: 96.14,
    r: 87.87,
    gradientTransform: "translate(-576)",
    gradientUnits: "userSpaceOnUse",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 169,
      columnNumber: 7
    }
  }, /*#__PURE__*/createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2,
    offset: 0,
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 177,
      columnNumber: 9
    }
  }), /*#__PURE__*/createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0,
    offset: 1,
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 178,
      columnNumber: 9
    }
  })), /*#__PURE__*/createElement("g", {
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 180,
      columnNumber: 7
    }
  }, /*#__PURE__*/createElement("path", {
    d: "M91.83 183.9l20.96-78.2 17.86 10.3z",
    fill: "url(#Google_Chrome_icon_svg__O)",
    className: "Google_Chrome_icon_svg__B",
    transform: "translate(-7 -7)",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 181,
      columnNumber: 9
    }
  }), /*#__PURE__*/createElement("g", {
    className: "Google_Chrome_icon_svg__B",
    transform: "translate(-7 -7)",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 187,
      columnNumber: 9
    }
  }, /*#__PURE__*/createElement("circle", {
    cx: 96,
    cy: 96,
    r: 40,
    fill: "#f1f1f1",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 188,
      columnNumber: 11
    }
  }), /*#__PURE__*/createElement("circle", {
    cx: 96,
    cy: 96,
    r: 32,
    fill: "#4285f4",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 189,
      columnNumber: 11
    }
  }), /*#__PURE__*/createElement("path", {
    d: "M96 55c-22.1 0-40 17.9-40 40v1c0-22.1 17.9-40 40-40h88v-1H96z",
    className: "Google_Chrome_icon_svg__C Google_Chrome_icon_svg__E",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 190,
      columnNumber: 11
    }
  }), /*#__PURE__*/createElement("path", {
    d: "M130.6 116c-6.92 11.94-19.8 20-34.6 20s-27.7-8.06-34.6-20h-.04L8 24.48v1L61.4 117c6.92 11.94 19.8 20 34.6 20s27.68-8.05 34.6-20h.05v-1h-.06z",
    fill: "#fff",
    fillOpacity: 0.1,
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 194,
      columnNumber: 11
    }
  }), /*#__PURE__*/createElement("path", {
    d: "M97 56c-.17 0-.33.02-.5.03C118.36 56.3 136 74.08 136 96s-17.64 39.7-39.5 39.97c.17 0 .33.03.5.03 22.1 0 40-17.9 40-40s-17.9-40-40-40z",
    opacity: 0.1,
    className: "Google_Chrome_icon_svg__C",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 199,
      columnNumber: 11
    }
  }), /*#__PURE__*/createElement("path", {
    d: "M131 117.3c3.4-5.88 5.37-12.68 5.37-19.96a39.87 39.87 0 00-1.87-12.09c.95 3.42 1.5 7 1.5 10.73 0 7.28-1.97 14.08-5.37 19.96l.02.04-38.88 68h1.16L131 117.3z",
    fill: "#fff",
    className: "Google_Chrome_icon_svg__E",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 204,
      columnNumber: 11
    }
  }), /*#__PURE__*/createElement("path", {
    d: "M96 9c48.43 0 87.72 39.13 88 87.5 0-.17.01-.33.01-.5 0-48.6-39.4-88-88-88S8 47.4 8 96c0 .17.01.33.01.5C8.28 48.13 47.57 9 96 9z",
    fill: "#fff",
    className: "Google_Chrome_icon_svg__E",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 209,
      columnNumber: 11
    }
  }), /*#__PURE__*/createElement("path", {
    d: "M96 183c48.43 0 87.72-39.13 88-87.5 0 .17.01.33.01.5 0 48.6-39.4 88-88 88S8 144.6 8 96c0-.17.01-.33.01-.5.27 48.37 39.56 87.5 88 87.5z",
    className: "Google_Chrome_icon_svg__C Google_Chrome_icon_svg__D",
    __self: this,
    __source: {
      fileName: _jsxFileName$4,
      lineNumber: 214,
      columnNumber: 11
    }
  }))));
}

var _jsxFileName$3 = "/builds/zillow/app-acquisition/app-upsell-utils/src/components/SafariLogo.js";

function SvgSafariBrowserLogo(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 66.166 65.804"
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 5,
      columnNumber: 5
    }
  }), /*#__PURE__*/createElement("defs", {
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 11,
      columnNumber: 7
    }
  }, /*#__PURE__*/createElement("linearGradient", {
    id: "Safari_browser_logo_svg__b",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 12,
      columnNumber: 9
    }
  }, /*#__PURE__*/createElement("stop", {
    offset: 0,
    stopColor: "#06c2e7",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 13,
      columnNumber: 11
    }
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.25,
    stopColor: "#0db8ec",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 14,
      columnNumber: 11
    }
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.5,
    stopColor: "#12aef1",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 15,
      columnNumber: 11
    }
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.75,
    stopColor: "#1f86f9",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 16,
      columnNumber: 11
    }
  }), /*#__PURE__*/createElement("stop", {
    offset: 1,
    stopColor: "#107ddd",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 17,
      columnNumber: 11
    }
  })), /*#__PURE__*/createElement("linearGradient", {
    id: "Safari_browser_logo_svg__a",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 19,
      columnNumber: 9
    }
  }, /*#__PURE__*/createElement("stop", {
    offset: 0,
    stopColor: "#bdbdbd",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 20,
      columnNumber: 11
    }
  }), /*#__PURE__*/createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 21,
      columnNumber: 11
    }
  })), /*#__PURE__*/createElement("linearGradient", {
    xlinkHref: "#Safari_browser_logo_svg__a",
    id: "Safari_browser_logo_svg__d",
    x1: 412.975,
    y1: 237.608,
    x2: 412.975,
    y2: 59.392,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.35154 0 0 .35154 206.79 159.773)",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 23,
      columnNumber: 9
    }
  }), /*#__PURE__*/createElement("filter", {
    id: "Safari_browser_logo_svg__f",
    x: -0.021,
    width: 1.042,
    y: -0.022,
    height: 1.045,
    colorInterpolationFilters: "sRGB",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 33,
      columnNumber: 9
    }
  }, /*#__PURE__*/createElement("feGaussianBlur", {
    stdDeviation: 0.958,
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 41,
      columnNumber: 11
    }
  })), /*#__PURE__*/createElement("filter", {
    id: "Safari_browser_logo_svg__c",
    x: -0.048,
    width: 1.096,
    y: -0.048,
    height: 1.096,
    colorInterpolationFilters: "sRGB",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 43,
      columnNumber: 9
    }
  }, /*#__PURE__*/createElement("feGaussianBlur", {
    stdDeviation: 3.564,
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 51,
      columnNumber: 11
    }
  })), /*#__PURE__*/createElement("radialGradient", {
    xlinkHref: "#Safari_browser_logo_svg__b",
    id: "Safari_browser_logo_svg__e",
    cx: 413.061,
    cy: 136.818,
    fx: 413.061,
    fy: 136.818,
    r: 82.125,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.38143 0 0 .38143 194.545 155.58)",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 53,
      columnNumber: 9
    }
  })), /*#__PURE__*/createElement("path", {
    transform: "matrix(.33865 0 0 .3261 -106.77 -14.478)",
    d: "M502.083 148.5a89.108 89.108 0 01-89.108 89.108 89.108 89.108 0 01-89.108-89.108 89.108 89.108 0 0189.108-89.108 89.108 89.108 0 0189.108 89.108z",
    opacity: 0.53,
    paintOrder: "markers stroke fill",
    filter: "url(#Safari_browser_logo_svg__c)",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 65,
      columnNumber: 7
    }
  }), /*#__PURE__*/createElement("path", {
    d: "M383.294 211.977a31.325 31.325 0 01-31.325 31.325 31.325 31.325 0 01-31.326-31.325 31.325 31.325 0 0131.326-31.325 31.325 31.325 0 0131.325 31.325z",
    fill: "url(#Safari_browser_logo_svg__d)",
    stroke: "#cdcdcd",
    strokeWidth: 0.093,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    paintOrder: "markers stroke fill",
    transform: "translate(-318.886 -180.595)",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 72,
      columnNumber: 7
    }
  }), /*#__PURE__*/createElement("path", {
    d: "M380.84 211.977a28.87 28.87 0 01-28.871 28.87 28.87 28.87 0 01-28.871-28.87 28.87 28.87 0 0128.87-28.87 28.87 28.87 0 0128.871 28.87z",
    fill: "url(#Safari_browser_logo_svg__e)",
    paintOrder: "markers stroke fill",
    transform: "translate(-318.886 -180.595)",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 82,
      columnNumber: 7
    }
  }), /*#__PURE__*/createElement("path", {
    d: "M33.083 4.017a.42.42 0 00-.421.42v4.856a.42.42 0 10.842 0V4.438a.42.42 0 00-.421-.421zm-2.754.174a.42.42 0 00-.46.463l.212 2.03a.42.42 0 10.837-.087l-.212-2.03a.42.42 0 00-.377-.376zm5.527.002a.42.42 0 00-.377.375l-.214 2.03a.42.42 0 10.837.089l.214-2.031a.42.42 0 00-.46-.463zM27.5 4.6a.42.42 0 00-.41.508l1.005 4.75a.42.42 0 10.824-.174l-1.005-4.75A.42.42 0 0027.5 4.6zm11.183.004a.42.42 0 00-.414.333l-1.009 4.75a.42.42 0 10.824.175l1.009-4.75a.42.42 0 00-.41-.508zm-13.883.757a.42.42 0 00-.437.55l.632 1.942a.42.42 0 10.8-.26l-.63-1.942a.42.42 0 00-.365-.29zm16.568.001a.42.42 0 00-.364.29l-.632 1.942a.42.42 0 10.8.26l.632-1.942a.42.42 0 00-.436-.55zM22.13 6.34a.42.42 0 00-.377.592l1.972 4.437a.42.42 0 10.77-.342l-1.972-4.437a.42.42 0 00-.393-.25zm21.937.015a.42.42 0 00-.392.25l-1.978 4.434a.42.42 0 10.769.343l1.978-4.434a.42.42 0 00-.377-.593zM19.654 7.65a.42.42 0 00-.394.63l1.02 1.77a.42.42 0 10.73-.421L19.989 7.86a.42.42 0 00-.335-.21zm26.858 0a.419.419 0 00-.335.21l-1.021 1.769a.42.42 0 10.73.42l1.02-1.768a.42.42 0 00-.394-.63zm-29.265 1.5a.422.422 0 00-.326.669l2.85 3.93a.42.42 0 10.682-.494l-2.85-3.93a.42.42 0 00-.356-.174zm31.702.022a.42.42 0 00-.356.174l-2.856 3.926a.42.42 0 10.681.495l2.856-3.926a.42.42 0 00-.325-.669zm-33.852 1.783a.42.42 0 00-.335.702l1.366 1.518a.42.42 0 10.626-.563l-1.367-1.518a.42.42 0 00-.29-.14zm35.975.003a.421.421 0 00-.29.139l-1.367 1.517a.42.42 0 10.625.564l1.367-1.518a.42.42 0 00-.335-.702zm-38.037 1.977a.42.42 0 00-.26.733l3.61 3.248a.42.42 0 10.563-.625l-3.609-3.248a.42.42 0 00-.304-.108zm40.109.014a.419.419 0 00-.304.108l-3.61 3.245a.42.42 0 10.562.626l3.61-3.245a.42.42 0 00-.258-.734zm-41.823 2.19a.42.42 0 00-.262.762l1.652 1.2a.42.42 0 10.495-.681l-1.652-1.2a.42.42 0 00-.233-.081zm43.535.015a.421.421 0 00-.233.08l-1.653 1.2a.42.42 0 10.495.681l1.653-1.2a.42.42 0 00-.262-.76zM9.72 17.49a.42.42 0 00-.18.785l4.204 2.427a.42.42 0 10.42-.729L9.96 17.546a.42.42 0 00-.24-.056zm46.728 0a.417.417 0 00-.24.056l-4.205 2.427a.42.42 0 10.42.73l4.206-2.428a.42.42 0 00-.181-.785zM8.508 19.996a.42.42 0 00-.18.806l1.866.831a.42.42 0 10.343-.768l-1.866-.832a.42.42 0 00-.163-.037zm49.158.017a.42.42 0 00-.164.037l-1.865.83a.42.42 0 10.342.77l1.866-.831a.42.42 0 00-.179-.806zM7.429 22.615a.42.42 0 00-.094.82l4.615 1.504a.42.42 0 10.261-.8l-4.616-1.504a.421.421 0 00-.166-.02zm51.314.018a.408.408 0 00-.166.02l-4.617 1.5a.42.42 0 10.26.801l4.617-1.5a.42.42 0 00-.094-.82zM6.756 25.365a.42.42 0 00-.09.833l1.998.424a.42.42 0 10.175-.823l-1.998-.425a.413.413 0 00-.085-.009zm52.655.004a.518.518 0 00-.085.009l-1.998.424a.42.42 0 10.175.823l1.998-.424a.42.42 0 00-.09-.833zM6.247 28.13a.42.42 0 00-.003.838l4.828.51a.42.42 0 10.089-.837l-4.829-.51a.432.432 0 00-.085 0zm53.676.037a.386.386 0 00-.085 0l-4.83.504a.42.42 0 10.088.837l4.83-.504a.42.42 0 00-.003-.837zM6.165 30.96a.42.42 0 100 .842h2.043a.42.42 0 100-.842zm51.793 0a.42.42 0 100 .842h2.043a.42.42 0 100-.842zm-46.803 2.295a.384.384 0 00-.085 0l-4.83.504a.42.42 0 10.088.838l4.83-.504a.42.42 0 00-.003-.838zm43.853.03a.42.42 0 00-.003.838l4.828.51a.42.42 0 10.089-.837l-4.828-.51a.434.434 0 00-.086-.001zm-46.26 2.843a.43.43 0 00-.085.01l-1.998.424a.42.42 0 10.175.823l1.998-.424a.42.42 0 00-.09-.833zm48.67.005a.42.42 0 00-.09.833l1.997.424a.42.42 0 10.175-.824l-1.998-.424a.413.413 0 00-.085-.01zM12.111 37.79a.408.408 0 00-.166.02l-4.617 1.5a.42.42 0 10.26.801l4.617-1.5a.42.42 0 00-.094-.82zm41.937.015a.42.42 0 00-.094.82l4.616 1.504a.42.42 0 10.26-.8l-4.615-1.504a.421.421 0 00-.167-.02zM10.35 41.08a.42.42 0 00-.163.036l-1.866.831a.42.42 0 10.342.769l1.866-.83a.42.42 0 00-.179-.806zm45.459.016a.42.42 0 00-.18.805l1.865.832a.42.42 0 10.343-.769l-1.865-.832a.42.42 0 00-.163-.036zm-41.826.912a.417.417 0 00-.24.056L9.538 44.49a.42.42 0 10.421.73l4.205-2.428a.42.42 0 00-.181-.785zm38.2 0a.42.42 0 00-.181.785l4.205 2.427a.42.42 0 10.42-.729l-4.204-2.427a.42.42 0 00-.24-.056zm-39.249 3.562a.421.421 0 00-.233.08l-1.653 1.2a.42.42 0 10.495.682l1.653-1.2a.42.42 0 00-.262-.762zm40.288.015a.42.42 0 00-.262.762l1.652 1.2a.42.42 0 10.495-.681l-1.652-1.2a.42.42 0 00-.233-.081zm-36.544.145a.418.418 0 00-.304.108l-3.61 3.245a.42.42 0 10.562.626l3.61-3.245a.42.42 0 00-.258-.734zm32.8.011a.421.421 0 00-.26.734l3.609 3.248a.42.42 0 10.563-.625l-3.608-3.249a.42.42 0 00-.304-.107zm-29.375 3.084a.42.42 0 00-.355.173l-2.856 3.927a.42.42 0 10.68.495l2.857-3.926a.42.42 0 00-.326-.669zm25.936.018a.421.421 0 00-.326.668l2.85 3.93a.42.42 0 10.682-.494l-2.851-3.93a.42.42 0 00-.355-.174zm-29.623.606a.421.421 0 00-.29.14l-1.367 1.517a.42.42 0 10.625.563l1.367-1.517a.42.42 0 00-.335-.703zm33.331.002a.42.42 0 00-.335.702l1.366 1.518a.42.42 0 10.626-.563l-1.366-1.518a.42.42 0 00-.291-.139zm-25.655 1.684a.419.419 0 00-.393.25l-1.978 4.433a.42.42 0 10.77.343l1.977-4.434a.42.42 0 00-.376-.592zm17.955.012a.42.42 0 00-.377.592l1.972 4.437a.42.42 0 10.77-.342l-1.972-4.437a.42.42 0 00-.393-.25zm-21.431 1.359a.419.419 0 00-.335.21l-1.021 1.768a.42.42 0 10.729.421l1.02-1.769a.42.42 0 00-.393-.63zm24.934 0a.42.42 0 00-.394.63l1.021 1.77a.42.42 0 10.73-.422l-1.022-1.769a.42.42 0 00-.335-.21zm-17.054.063a.42.42 0 00-.415.334l-1.009 4.749a.42.42 0 10.824.175l1.009-4.75a.42.42 0 00-.41-.508zm9.16.003a.42.42 0 00-.41.508l1.006 4.75a.42.42 0 10.823-.175l-1.006-4.75a.42.42 0 00-.414-.333zm-4.573.48a.42.42 0 00-.421.42v4.855a.42.42 0 10.842 0v-4.855a.42.42 0 00-.421-.42zm-7.727 1.568a.42.42 0 00-.364.29l-.631 1.942a.42.42 0 10.8.26l.632-1.942a.42.42 0 00-.437-.55zm15.45 0a.42.42 0 00-.437.55l.632 1.943a.42.42 0 10.8-.26l-.63-1.942a.42.42 0 00-.365-.29zm-10.365 1.083a.42.42 0 00-.378.375l-.213 2.03a.42.42 0 10.837.088l.214-2.03a.42.42 0 00-.46-.463zm5.267.002a.42.42 0 00-.46.463l.212 2.03a.42.42 0 10.837-.088l-.212-2.03a.42.42 0 00-.377-.375z",
    fill: "#f4f2f3",
    paintOrder: "markers stroke fill",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 88,
      columnNumber: 7
    }
  }), /*#__PURE__*/createElement("path", {
    transform: "matrix(.35154 0 0 .35154 -112.095 -20.822)",
    d: "M469.096 100.607l-65.51 38.061-41.42 65.207 60.595-44.882z",
    opacity: 0.409,
    paintOrder: "markers stroke fill",
    filter: "url(#Safari_browser_logo_svg__f)",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 93,
      columnNumber: 7
    }
  }), /*#__PURE__*/createElement("path", {
    d: "M36.383 34.838l-6.6-6.913 23.416-15.752z",
    fill: "#ff5150",
    paintOrder: "markers stroke fill",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 100,
      columnNumber: 7
    }
  }), /*#__PURE__*/createElement("path", {
    d: "M36.383 34.838l-6.6-6.913L12.966 50.59z",
    fill: "#f1f1f1",
    paintOrder: "markers stroke fill",
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 105,
      columnNumber: 7
    }
  }), /*#__PURE__*/createElement("path", {
    d: "M12.967 50.59l23.416-15.752L53.2 12.173z",
    opacity: 0.243,
    __self: this,
    __source: {
      fileName: _jsxFileName$3,
      lineNumber: 110,
      columnNumber: 7
    }
  }));
}

var _jsxFileName$2 = "/builds/zillow/app-acquisition/app-upsell-utils/src/components/ZillowLogo.js",
    _this$1 = undefined;

var ZillowLogo = function ZillowLogo() {
  return /*#__PURE__*/React.createElement("svg", {
    x: "0px",
    y: "0px",
    viewBox: "1 1 43 43",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 5,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("title", {
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 6,
      columnNumber: 7
    }
  }, "AppIcon45x45"), /*#__PURE__*/React.createElement("desc", {
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 7,
      columnNumber: 7
    }
  }, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
    id: "AppIcon45x45",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 8,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "zlogo",
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 9,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#006AFF",
    points: "4 41.0002535 41 41.0002535 41 4 4 4",
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 10,
      columnNumber: 15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(9.859551, 7.707640)",
    fill: "#FFFFFF",
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 11,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7675674,8.04208146 C17.8954888,8.02160393 17.9503483,8.0714073 18.0175955,8.16267135 C18.4051517,8.6844691 19.6406292,10.4923062 19.9786348,10.9870534 C20.0423427,11.0805927 19.987736,11.163514 19.9245337,11.2044691 C16.9421461,13.1387107 13.5666404,15.948177 11.6417528,18.0027556 C11.6002921,18.0467444 11.6311348,18.0530646 11.6559101,18.0444691 C14.7465,17.024132 21.8656011,15.5982893 25.1682978,15.2729242 L25.1685506,10.0969129 L12.6337753,0.189328652 L0.077005618,10.0969129 L0.077005618,13.5244972 C4.12852247,11.5576433 13.6010225,8.70115449 17.7675674,8.04208146",
    id: "Fill-2",
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 12,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1210618,24.1250815 C6.01058427,24.1705871 5.92968539,24.150868 5.85308427,24.0611208 L3.76538764,21.0797444 C3.70698876,20.9985927 3.70395506,20.9583961 3.79850562,20.8428624 C5.83108989,18.3592669 9.8674382,14.5696601 12.3656966,13.0368792 C12.4096854,13.0095758 12.4015955,12.978986 12.3512865,12.990868 C9.8841236,13.5655028 2.87575281,15.8690983 0.0771573034,17.1108961 L0.0774101124,27.7493511 L25.1684494,27.7493511 L25.1684494,19.6943511 C21.6463146,19.9916545 10.9449101,22.1521601 6.1210618,24.1250815",
    id: "Fill-4",
    __self: _this$1,
    __source: {
      fileName: _jsxFileName$2,
      lineNumber: 13,
      columnNumber: 19
    }
  })))));
};

var _jsxFileName$1 = "/builds/zillow/app-acquisition/app-upsell-utils/src/components/ZillowHomeLogo.js",
    _templateObject,
    _this = undefined;
var StyledZillowLogo = styled.svg(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    color: ", ";\n"])), function (props) {
  return props.fontColor;
});

var ZillowHomeLogo = function ZillowHomeLogo(_ref) {
  var rest = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(StyledZillowLogo, _extends({
    viewBox: "0 0 364 400"
  }, rest, {
    __self: _this,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 14,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    __self: _this,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 15,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.2 107.8c1.8-.4 2.7.2 3.8 1.5 6.2 7 26.4 31.6 31.9 38.3a2.1 2.1 0 0 1-.5 3.2 727.8 727.8 0 0 0-111.1 108.8c-.6.7-.1.8.2.6 44-18.9 147.1-49 193.7-57.5v-58.9L182.2 0 0 143.8v64.3c56.5-33.5 187-85.5 246.2-100.3z",
    __self: _this,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 16,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2 355.2a3 3 0 0 1-4-.6l-34-40.5c-1-1-1-1.7.2-3.4 26.2-38.5 79.8-98.4 114-123.8.6-.4.4-.9-.3-.6-35.5 11.6-136.7 55-174.1 76.2V400h364.2V267.7c-49.8 8.4-198.4 52.7-266 87.5z",
    __self: _this,
    __source: {
      fileName: _jsxFileName$1,
      lineNumber: 17,
      columnNumber: 17
    }
  })));
};

ZillowHomeLogo.propTypes = process.env.NODE_ENV !== "production" ? {
  fontColor: PropTypes.string
} : {};
ZillowHomeLogo.defaultProps = {
  fontColor: '#006AFF'
};

var localStorageSupported = isLocalStorageSupported();
var getStoredDismiss = function getStoredDismiss(key) {
  return localStorageSupported ? localStorage.getItem(key) : null;
};
var setStoredDismiss = function setStoredDismiss(key, timeStamp) {
  if (localStorageSupported) {
    localStorage.setItem(key, timeStamp);
  }
};
var getRequestId = function getRequestId() {
  return v4();
};
var userAgent = get(global, 'window.navigator.userAgent') || '';
var QUERY_FOR_IOS = ['iPhone', 'iPad'];

var isUserAgentMatch = function isUserAgentMatch(agent) {
  return userAgent && userAgent.indexOf(agent) > -1;
};

var isIOS = function isIOS() {
  return QUERY_FOR_IOS.some(function (device) {
    return isUserAgentMatch(device);
  });
};
var isSafari = function isSafari() {
  var re = /CriOS\/[.0-9]*/g;
  return isIOS() && re.exec(userAgent) === null;
};
var getAdjustTrackerForTrial = function getAdjustTrackerForTrial(abs, trial, adjustTrackers) {
  var treatment = get(abs, trial + ".treatment");
  return treatment ? get(adjustTrackers, trial + "." + treatment) : null;
};
var isTreatmentForTrial = function isTreatmentForTrial(_ref) {
  var abs = _ref.abs,
      trial = _ref.trial,
      treatment = _ref.treatment;
  return Boolean(treatment && get(abs, trial + ".treatment") === treatment);
};
var getDismissKey = function getDismissKey(abs) {
  var treatment = get(abs, 'ACQ_MOBILE_UPSELL_DISMISS_KEY.treatment');
  return treatment ? treatment : APP_UPSELL_DISMISS;
};
var getAdjustDeepLinkForAndroid = function getAdjustDeepLinkForAndroid(adjustTracker, requestId, deepLink) {
  var encodedDeepLink = encodeURIComponent(deepLink);
  return ADJUST_BASE_UNIVERSAL_LINK + "/?requestid=" + requestId + "&adj_t=" + adjustTracker + "&adj_deep_link=" + encodedDeepLink;
};
var getAdjustUniversalLink = function getAdjustUniversalLink(adjustTracker, requestId, deepLink, queryParams) {
  if (queryParams === void 0) {
    queryParams = {};
  }

  var query = '';

  for (var prop in queryParams) {
    query += "&" + prop + "=" + queryParams[prop];
  }

  return ADJUST_BASE_UNIVERSAL_LINK + "/universallink/" + deepLink + "?requestid=" + requestId + "&adj_t=" + adjustTracker + query;
};

var _jsxFileName = "/builds/zillow/app-acquisition/app-upsell-utils/src/withImpression.js";

var withImpression = function withImpression(WrappedComponent) {
  return /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(_class, _React$Component);

    function _class() {
      return _React$Component.apply(this, arguments) || this;
    }

    var _proto = _class.prototype;

    _proto.render = function render() {
      return /*#__PURE__*/React.createElement(TrackImpression, _extends({}, this.props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 9,
          columnNumber: 17
        }
      }), /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 10,
          columnNumber: 21
        }
      })));
    };

    return _class;
  }(React.Component);
};

export { ACQ_Banner_Suppression, ACQ_Deeplink_DirectOpen, ADJUST_BASE_UNIVERSAL_LINK, ADJUST_BASE_URL, SvgGoogleChromeIcon as ChromeLogo, DEFAULT_ADJUST_TRACKER, DEFAULT_DISMISS_KEY, DISMISS_DURATION, DISMISS_DURATION_24_HRS, SITEWIDE_ADJUST_TRACKERS, SvgSafariBrowserLogo as SafariLogo, TrackImpression, ZillowHomeLogo, ZillowLogo, getAdjustDeepLinkForAndroid, getAdjustTrackerForTrial, getAdjustUniversalLink, getDismissKey, getRequestId, getStoredDismiss, isIOS, isSafari, isTreatmentForTrial, setStoredDismiss, trackError, trackInteraction, withImpression };
